<template>
  <div class="d-flex flex-wrap align-items-start align-content-center">
    <div v-for="item in items" :key="item" class="d-flex align-items-center">
      <span class="material-icons md-12">check_box</span>
      <p class="ms-1 me-2">{{ item }}</p>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import core from '../../../utils/mixin-core'

export default {
  name: 'CheckBoxListField',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  mixins: [core],
  computed: {
    regex() {
      return new RegExp(`\\s*${this.CORE.CORE.groupConcatDelimeter}\\s*`)
    },
    items() {
      if (this.content === null || isEmpty(this.content)) {
        return []
      }
      return this.content.split(this.regex)
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  word-break: break-word;
}
</style>
